export { default as NewMemorandum } from "./NewMemorandum";
